import { render } from "./RadioMenuDetailTable.vue?vue&type=template&id=62dca25c&scoped=true&ts=true"
import script from "./RadioMenuDetailTable.vue?vue&type=script&lang=ts"
export * from "./RadioMenuDetailTable.vue?vue&type=script&lang=ts"

import "./RadioMenuDetailTable.vue?vue&type=style&index=0&id=62dca25c&lang=scss&scoped=true"

import exportComponent from "/root/workspace/lll-ui_hccl/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62dca25c"]])

export default __exports__